import type { RuleGroupType } from 'react-querybuilder';

import type { PolicyCategoryInfoListPolicyCategoryInfo } from '~/server_shared/openapi/data-contracts';

// The generated `PolicyCategoryInfo` contract, with the one field the screen needs narrowed:
// `conditions_json` arrives as an untyped object but is always the RQB tree the query-builder
// components consume. Derived rather than re-typed so the row cannot drift from the BE schema.
export type PolicyCategoryRow = Omit<PolicyCategoryInfoListPolicyCategoryInfo, 'conditions_json'> & {
  conditions_json: RuleGroupType | null;
};

export const policyCategoriesUrl = (organizationId: number, incidentConfigurationId: number): string =>
  `/sysconfig/api/v1/organizations/${organizationId}/incident_configurations/${incidentConfigurationId}/policy_categories`;
